import SafeAreaInsetPage from "../SafeAreaInsetPage/SafeAreaInsetPage";
import styles from "./PushedScreen.module.scss";

interface Props {
  visible: boolean;
}

const PushedScreen = (props: React.PropsWithChildren<Props>) => {
  if (!props.visible) {
    return <></>;
  }

  return (
    <>
      <div className={`${styles.screen} ${styles.pushIn}`}>
        <SafeAreaInsetPage>{props.children}</SafeAreaInsetPage>
      </div>
    </>
  );
};

export default PushedScreen;
